// extracted by mini-css-extract-plugin
export var warning = "ConfirmDetailsMessages-module--warning--GPUvK";
export var warningContainer = "ConfirmDetailsMessages-module--warningContainer--K0M9W";
export var warningItems = "ConfirmDetailsMessages-module--warningItems--dZiH6";